import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { restoreSession } from './features/session.slice';

/**
 * Enhances a given reducer builder with a case for rehydrating slice state from a session restore action.
 * Specifically, it handles the `restoreSession` action by checking if the payload contains state
 * for the specified slice name. If the slice's state is found in the payload, it updates the current
 * state of the slice with the payload's state. If not found, it logs a warning message and retains
 * the current state.
 *
 * Keep reducers and slice name in sync, otherwise rehydrated state could not match.
 *
 * @param {ActionReducerMapBuilder<any>} builder - The reducer builder.
 * @param {string} sliceName - The name of the slice for which the state may be restored.
 * @returns {ActionReducerMapBuilder<any>} The modified builder with the added rehydration case.
 */
export const saveAndContinueRehydrateSlice = (
  builder: ActionReducerMapBuilder<any>,
  sliceName: string
): ActionReducerMapBuilder<any> => {
  return builder.addCase(restoreSession, (state, action) => {
    if (action.payload && action.payload[sliceName]) {
      return action.payload[sliceName];
    }

    // eslint-disable-next-line no-console
    console.warn(`No Save And Continue data for ${sliceName} slice`);
    return state;
  });
};
